module.exports = __webpack_public_path__ + "img/nullDate.fff4daa5.png";